var $ = require('../internals/export');
var isInteger = require('../internals/is-integer');

// `Number.isInteger` method
// https://tc39.github.io/ecma262/#sec-number.isinteger
$({ target: 'Number', stat: true }, {
  isInteger: isInteger
});



//////////////////
// WEBPACK FOOTER
// ./~/handsontable/~/core-js/modules/es.number.is-integer.js
// module id = 54Mk
// module chunks = 0